"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentToken = void 0;

var _tokens = _interopRequireDefault(require("@creditas-ui/tokens"));

var componentToken = {
  footer: {
    fontFamily: _tokens.default.fontFamily.base,
    main: {
      backgroundColor: _tokens.default.colors.neutral[10],
      baseText: {
        fontWeight: _tokens.default.fontWeight.sm,
        color: _tokens.default.colors.neutral[90],
        xs: {
          fontSize: _tokens.default.fontSizes.md,
          lineHeight: _tokens.default.lineHeight.md,
          letterSpacing: _tokens.default.letterSpacing.xs
        },
        md: {
          fontSize: _tokens.default.fontSizes.sm,
          lineHeight: _tokens.default.lineHeight.sm,
          letterSpacing: _tokens.default.letterSpacing.xs
        }
      },
      title: {
        color: _tokens.default.colors.neutral[90],
        fontWeight: _tokens.default.fontWeight.lg
      },
      links: {
        color: _tokens.default.colors.neutral[60],
        fontWeight: _tokens.default.fontWeight.sm
      }
    },
    legal: {
      backgroundColor: _tokens.default.colors.neutral[90],
      fontSize: _tokens.default.fontSizes.xs,
      lineHeight: _tokens.default.lineHeight.xs,
      fontWeight: _tokens.default.fontWeight.sm,
      stamp: {
        color: _tokens.default.colors.neutral[20]
      },
      text: {
        letterSpacing: _tokens.default.letterSpacing.xs,
        color: _tokens.default.colors.neutral[40]
      },
      divider: {
        color: _tokens.default.colors.neutral[80]
      },
      links: {
        letterSpacing: _tokens.default.letterSpacing.xs,
        color: _tokens.default.colors.neutral[40],
        dotColor: _tokens.default.colors.primary[40]
      },
      circle: {
        color: _tokens.default.colors.primary[40]
      }
    }
  }
};
exports.componentToken = componentToken;